/****************************************************
 * Module Name:  AddConsigneeMasterModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField, CircularProgress, Tooltip } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import ConsigneeMasterProxy from "../../utility/proxy/nivodautility/consigneeMasterProxy";
import Select from "react-select";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

export default class AddConsigneeMasterModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newconsigneename: this.props.editOperation
                ? this.props.sourceData.consigneename
                : "",
            newcountryofdestination: this.props.editOperation
                ? this.props.sourceData.countryofdestination
                : "",
            newuserid: this.props.editOperation
                ? this.props.sourceData.mappedtoid
                : "",
            newupdatedbyid: this.props.editOperation
                ? this.props.sourceData.updatedbyid
                : "",

            showError: false,
            validateConsigneeNamePresentSpinner: false,
            consigneeNameAvailable: true,

            validateCutPresentSpinner: false,
            showValidationMessage: false,

            consigneenameValidationError: "",
            countryofdestinationValidationError: "",
            userOptions: this.props.userOptions || [],
            selectedUser: this.props.selectedUser || [],
            companyOptions: this.props.companyOptions || [],
            selectedCompany: this.props.selectedCompany || [],

            showUserDetailModal: false,
            userDetailContext: "",
        };
    }

    validateConsigneeNamePresent = (consigneeNameEntered) => {
        if (!consigneeNameEntered || consigneeNameEntered.trim() === "") return;

        this.setState({
            validateConsigneeNamePresentSpinner: true,
        });

        ConsigneeMasterProxy.CheckConsigneeNameAvailable(consigneeNameEntered, (response) => {
            if (response) {
                //consigneeName already present
                this.setState({
                    validateConsigneeNamePresentSpinner: false,
                    showValidationMessage: true,
                    consigneeNameAvailable: false,
                });
            } else {
                //consigneeName not available, so can be used
                this.setState({
                    validateConsigneeNamePresentSpinner: false,
                    showValidationMessage: true,
                    consigneeNameAvailable: true,
                });
            }
        });
    };

    consigneeNameValidation = (e) => {

        this.setState({
            newconsigneename: e.target.value.toUpperCase(),
            showValidationMessage: false,
            consigneenameValidationError: Utility.CheckIsPresent(e.target.value)
                ? ""
                : "Enter valid consignee name",
        });

        if (e.key === 'Enter' || e.type === 'blur') {
            if (Utility.CheckIsPresent(e.target.value)) {
                this.validateConsigneeNamePresent(e.target.value);
            } else {
                this.setState({
                    consigneenameValidationError: "Enter valid consignee name",
                });
            }
        }
    }

    handleSave = () => {
        let data = {
            id: this.props.editOperation ? this.props.sourceData.consigneeid : undefined,
            consigneename: this.state.newconsigneename,
            countryofdestination: this.state.newcountryofdestination,
            userid: this.state.newuserid,
            updatedby: this.state.newupdatedbyid,
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data))
                    this.props.handleSave(data);
                else
                    this.setState({
                        showError: true,
                    });
            } else
                this.props.handleSave(data);
        }
    };

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add consignee validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />
                {this.state.showUserDetailModal && (
                    <UserDetailModal
                        show={true}
                        handleClose={() => this.setState({ showUserDetailModal: false })}
                        handleSelect={(selectedOption) => {
                            if (this.state.userDetailContext === "C") {
                                const selectedData = this.state.companyOptions.filter(opt => selectedOption.includes(opt.value));
                                const selectedUser = this.state.userOptions.filter(opt => selectedOption.includes(opt.value));
                                this.setState({
                                    userDetailContext: "",
                                    showUserDetailModal: false,
                                    selectedUser: selectedUser[0],
                                    newuserid: selectedOption,
                                    selectedCompany: selectedData[0],
                                    newupdatedbyid: Constants.loggedInUser.id,
                                });
                            } else if (this.state.userDetailContext === "U") {
                                const selectedCompany = this.state.companyOptions.filter(opt => selectedOption.includes(opt.value));
                                const selectedData = this.state.userOptions.filter(opt => selectedOption.includes(opt.value));
                                this.setState({
                                    userDetailContext: "",
                                    showUserDetailModal: false,
                                    newuserid: selectedOption,
                                    selectedUser: selectedData[0],
                                    selectedCompany: selectedCompany[0],
                                    newupdatedbyid: Constants.loggedInUser.id
                                });
                            }
                        }}
                        userids={this.state.userDetailContext === "C" ?
                            (this.state.companyOptions.filter(opt => opt.value !== "*")).map(cust => cust.value) :
                            (this.state.userOptions.filter(opt => opt.value !== "*")).map(cust => cust.value)}
                        selectedIds={
                            this.state.userDetailContext === "C"
                                ? this.state.selectedCompany ? [this.state.selectedCompany.value] : []
                                : this.state.selectedUser ? [this.state.selectedUser.value] : []
                        }
                        usertype={"U"}
                        loading={this.state.showUserDetailModal}
                        isMulti={false}
                    />
                )}
                <Modal show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            {this.props.editOperation ? "Edit Consignee" : "Add New Consignee"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    {this.props.editOperation && (
                                        <tr>
                                            <td>
                                                <Form.Label>Consignee Id</Form.Label>
                                            </td>
                                            <td>
                                                <Form.Label>{this.props.sourceData.consigneeid}</Form.Label>
                                            </td>
                                        </tr>
                                    )}
                                    {this.props.editOperation && (
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Consignee Name <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td width={"70%"}>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Consignee Name (required)"
                                                placeholder="Enter Consignee Name"
                                                value={this.state.newconsigneename}
                                                onChange={(e) => this.consigneeNameValidation(e)}
                                                onBlur={(e) => { this.consigneeNameValidation(e) }}
                                                onKeyDown={(e) => { this.consigneeNameValidation(e) }}
                                                helperText={this.state.consigneenameValidationError}
                                                error={this.state.consigneenameValidationError.length > 0}
                                            />
                                            {this.state.validateConsigneeNamePresentSpinner ? (
                                                <CircularProgress size="1rem" />
                                            ) : !this.state.showValidationMessage ? (
                                                <div />
                                            ) : this.state.consigneeNameAvailable !== undefined && (this.state.consigneeNameAvailable ? (
                                                <font style={{ fontSize: "14px", fontWeight: "500", color: "#4EC073" }}>Consignee Name available</font>
                                            ) : (
                                                <font style={{ fontSize: "14px", fontWeight: "500", color: "red" }}>Consignee Name not available</font>
                                            ))}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Country Of Destination <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Country Of Destination"
                                                placeholder="Enter Country Of Destination"
                                                value={this.state.newcountryofdestination}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newcountryofdestination: e.target.value,
                                                        newupdatedbyid: Constants.loggedInUser.id,
                                                        countryofdestinationValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "Country Of Destination Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.countryofdestinationValidationError}
                                                error={this.state.countryofdestinationValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Mapped to company
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <div style={{ flex: 1 }}>
                                                    <Select
                                                        menuPlacement="auto"
                                                        blurInputOnSelect={false}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        value={this.state.selectedCompany}
                                                        isSearchable={true}
                                                        name="Mapped to ID"
                                                        options={this.state.companyOptions}
                                                        onChange={(selectedOption) => {
                                                            const selectedUser = this.state.userOptions.find(option => option.value === selectedOption.value);
                                                            this.setState({
                                                                newuserid: selectedOption.value,
                                                                selectedCompany: selectedOption,
                                                                selectedUser: selectedUser,
                                                                newupdatedbyid: Constants.loggedInUser.id,
                                                            });
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        styles={Constants.Styles}
                                                    />
                                                </div>
                                                <Tooltip title="View More Data">
                                                    <span style={{ cursor: "pointer" }}>
                                                        <OpenInNewIcon
                                                            style={{ fontSize: '20px', marginBottom: "3px" }}
                                                            onClick={() => {
                                                                this.setState({ showUserDetailModal: true, userDetailContext: "C" });
                                                            }}
                                                            color="action"
                                                        />
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Mapped to user
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <div style={{ flex: 1 }}>
                                                    <Select
                                                        menuPlacement="auto"
                                                        blurInputOnSelect={false}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        value={this.state.selectedUser}
                                                        isSearchable={true}
                                                        name="Mapped to user"
                                                        options={this.state.userOptions}
                                                        onChange={(selectedOption) => {
                                                            const selectedCompany = this.state.companyOptions.find(option => option.value === selectedOption.value);
                                                            this.setState({
                                                                newuserid: selectedOption.value,
                                                                selectedUser: selectedOption,
                                                                selectedCompany: selectedCompany,
                                                                newupdatedbyid: Constants.loggedInUser.id
                                                            });
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        styles={Constants.Styles}
                                                    />
                                                </div>
                                                <Tooltip title="View More Data">
                                                    <span style={{ cursor: "pointer" }}>
                                                        <OpenInNewIcon
                                                            style={{ fontSize: '20px', marginBottom: "3px" }}
                                                            onClick={() => {
                                                                this.setState({ showUserDetailModal: true, userDetailContext: "U" });
                                                            }}
                                                            color="action"
                                                        />
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.state.newconsigneename.length > 0 && this.state.newcountryofdestination.length > 0 ? false : true}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
}